// extracted by mini-css-extract-plugin
module.exports = {"ReportTitle":"Page_ReportTitle__nkoVR","MainWrapper":"Page_MainWrapper__HCxDf"};